import React from 'react';

const LineSvgIcon: React.FC = () => (
  <svg
    width='220'
    height='64'
    viewBox='0 0 220 64'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <mask id='path-1-inside-1_8328_60383' fill='white'>
      <path d='M0 0H220V64H0V0Z' />
    </mask>
    <path
      d='M0 0V-2H-2V0H0ZM0 0V2H220V0V-2H0V0ZM0 64H2V0H0H-2V64H0Z'
      fill='#FF5612'
      mask='url(#path-1-inside-1_8328_60383)'
    />
  </svg>
);

export default LineSvgIcon;
